export default {
  name: 'image',
  component_path: 'modules/procedures/blocks/static/BlockImage'
}